const ModuloMensagem = Object.freeze({
  PEDIDOS_COMPRA: 'Pedidos de Compra',
  FIDELIDADE: 'Fidelidade',
  CHECKLISTS_OPERACAO: 'Checklists de Operação',
});

export default ModuloMensagem;
